import { DeleteDraft, DeleteDraftToken } from "$src/application/projects/sub/drafts/commands/DeleteDraft";
import { DraftIdentifier } from "$src/domain/projects/drafts/DraftIdentifier";
import { useMutation } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function deleteDraft(groupStoreId: number, projectId: number)
    : Promise<DraftIdentifier> {

    const query = container.resolve<DeleteDraft>(DeleteDraftToken);
    return query.execute(groupStoreId, projectId);
}

export function useDeleteDraft() {
    return useMutation(
        ({ groupStoreId, projectId }: 
            { groupStoreId: number, projectId: number }
        ) => deleteDraft(groupStoreId, projectId)
    );
}